import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import bellplus from '../../images/BellPlus-Logo.svg';
import { Row, Col, Card, Form, Container } from 'reactstrap';
import { ToastsStore, ToastsContainer, ToastsContainerPosition } from 'react-toasts';
import routes from '../../constants/Routes';
import * as api from '../../util/apis';
import { ENV } from '../../constants/Constants';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { FormHelperText } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { validateEmail, numOnly } from 'util/uitilities';
import { Link, useNavigate } from 'react-router-dom';
import { validateSchema } from 'validations/common';
import { registerValidationSchema } from 'validations/register.validation';
import theme from 'theme';
import { useAppDispatch, useAppSelector } from 'Stores/Hooks/hooks';
import {
	checkUsernameThunk,
	checkClientCompanyNameThunk,
	RegisterState,
} from 'Stores/Slices/registerSlice';
import { SEND_MESSAGE } from 'Stores/Slices/errorHandlingSlice';
import { RootState } from 'Stores/store';
const PREFIX = 'Registration';

const classes = {
	formControl: `${PREFIX}-formControl`,
	selectEmpty: `${PREFIX}-selectEmpty`,
	textInput: `${PREFIX}-textInput`,
	textInputLabel: `${PREFIX}-textInputLabel`,
};

const Root = styled('div')(({ theme: Theme }) => ({
	[`& .${classes.formControl}`]: {
		marginTop: theme.spacing(2),
		marginBottom: theme.spacing(2),
		minWidth: 120,
		textAlign: 'left',
	},

	[`& .${classes.selectEmpty}`]: {},

	[`& .${classes.textInput}`]: {
		height: 50,
	},

	[`& .${classes.textInputLabel}`]: {
		fontSize: '1rem',
		lineHeight: 1,
	},
}));

interface HandleEvent {
	name: string;
	value: any;
}

interface CategoryInt {
	id: any;
	category: string;
}

const Registration = (props: any) => {
	const navigate = useNavigate();
	const [loginError, setLoginError] = useState('');
	const [firstName, setFirstName] = useState('');
	const [lastName, setLastName] = useState('');
	const [email, setEmail] = useState('');
	const [confirmEmail, setConfirmEmail] = useState('');
	const [userName, setUserName] = useState('');
	const [phoneNumber, setPhoneNumber] = useState('');
	const [, setUserType] = useState('');
	const [businessCategory, setBusinessCategory] = useState('');
	const [companyName, setCompanyName] = useState('');
	const [GSTNumber, setGSTNumber] = useState('');
	const [, setPAN] = useState('');
	const [country, setCountry] = useState('');
	const [state, setState] = useState('');
	const [city, setCity] = useState('');
	const [zipCode, setZipCode] = useState('');
	const [address, setAddress] = useState('');
	const [password, setPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const [errorObj, setErrorObj] = useState<any>({});
	const dispatch = useAppDispatch();
	const registerStore: RegisterState = useAppSelector(
		(state: RootState) => state.register,
	);
	const { isUsernameExists, isCompanyNameExists } = registerStore;
	const handleOnChange = (event: any) => {
		const { name, value }: HandleEvent = event.target;
		switch (name) {
			case 'firstName':
				setFirstName(value);
				break;
			case 'lastName':
				setLastName(value);
				break;
			case 'email':
				setEmail(value);
				break;
			case 'confirmEmail':
				setConfirmEmail(value);
				break;
			case 'userName':
				setUserName(value);
				if (value) dispatch(checkUsernameThunk(value));
				break;
			case 'phoneNumber':
				setPhoneNumber(value);
				break;
			case 'userType':
				setUserType(value);
				break;
			case 'businessCategory':
				setBusinessCategory(value);
				break;
			case 'companyName':
				setCompanyName(value);

				if (value) dispatch(checkClientCompanyNameThunk(value));
				break;
			case 'GSTNumber':
				setGSTNumber(value);
				break;
			case 'PAN':
				setPAN(value);
				break;
			case 'country':
				setCountry(value);
				break;
			case 'state':
				setState(value);
				break;
			case 'city':
				setCity(value);
				break;
			case 'zipCode':
				setZipCode(value);
				break;
			case 'address':
				setAddress(value);
				break;
			case 'password':
				setPassword(value);
				break;
			case 'confirmPassword':
				setConfirmPassword(value);
				break;
		}
	};

	const [businessCategoryData, setBusinessCategoryData] = useState([]);

	useEffect(() => {
		getBusinessCategory();
	}, []);

	const getBusinessCategory = async () => {
		try {
			const resp: any = await api.businessCategory(ENV.dev.businessCategoryUrl);
			setBusinessCategoryData(resp.data.data);
		} catch (error) {
			console.error(error);
		}
	};

	const saveRegestration = async (e: any): Promise<any> => {
		e.preventDefault();

		const advertiserData = {
			firstName,
			lastName,
			emailId: email,
			confirmEmailId: confirmEmail,
			username: userName,
			phoneNumber,
			gstNumber: GSTNumber,
			businessCategory: businessCategory,
			address,
			state,
			city,
			pinCode: zipCode,
			password,
			companyName,
			confirmPassword: confirmPassword,
		};

		const data = advertiserData;
		validateSchema(registerValidationSchema, data)
			.then(async () => {
				if (isUsernameExists || isCompanyNameExists) {
					return;
				}
				try {
					const res: any = await api.login(ENV.dev.register, data);
					setErrorObj({});
					dispatch(
						SEND_MESSAGE({
							message: 'User Created Successfully',
							type: 'success',
						}),
					);
					setTimeout(() => {
						navigate(routes.LOGIN.path);
					}, 2000);
				} catch (error: any) {
					dispatch(SEND_MESSAGE({ message: error, type: 'error' }));
				}
			})
			.catch((error) => {
				setErrorObj(error);
			});
	};

	const renderBusinessCategoryOptions = () => {
		return (
			businessCategoryData &&
			businessCategoryData.map(({ id, category }: CategoryInt) => (
				<MenuItem value={category} key={id}>
					{category}
				</MenuItem>
			))
		);
	};

	return (
		<Root className="app_background">
			<ToastsContainer
				className="toast"
				store={ToastsStore}
				position={ToastsContainerPosition.TOP_CENTER}
			/>
			<Container className="container-bellpluslogo">
				<Card className="card-logo">
					<Row className="m-0 p-0">
						<Col
							style={{ backgroundColor: '#393937' }}
							lg="4"
							md="4"
							sm="12"
							xs="12">
							<div className="logintext">
								<h1 className="login-main-heading">
									WE SHOUT OUT <br /> YOUR BRAND ..!!
								</h1>
								<h5 className="login-sub-heading">
									Indias digital out of home(DOOH)
									<br /> market is expected to grow
									<br /> rapidly over the next five years
								</h5>
							</div>
							<div className="registration-image" />
						</Col>
						<Col lg="8" md="8" sm="12" xs="12" className="registration-form ">
							<div>
								<form noValidate className="p-5">
									<Row>
										<Col md="3" sm="3" xs="3">
											<img src={bellplus} alt="bell plus logo" />
										</Col>
									</Row>
									<Row>
										<Col md="12" sm="12" xs="12">
											<p className="register-text">REGISTER NOW</p>
										</Col>
									</Row>
									<Row>
										<Col lg="6" md="6" sm="12" xs="12">
											<TextField
												variant="outlined"
												margin="normal"
												required
												fullWidth
												autoComplete="off"
												label="First Name"
												name="firstName"
												autoFocus
												value={firstName}
												onChange={handleOnChange}
												InputProps={{
													className: classes.textInput,
												}}
												InputLabelProps={{
													className: classes.textInputLabel,
												}}
											/>
											<FormHelperText error={true}>
												{errorObj.firstName}
											</FormHelperText>
										</Col>
										<Col lg="6" md="6" sm="12" xs="12">
											<TextField
												value={lastName}
												onChange={handleOnChange}
												variant="outlined"
												margin="normal"
												required
												fullWidth
												autoComplete="off"
												name="lastName"
												label="Last Name"
												InputProps={{
													className: classes.textInput,
												}}
												InputLabelProps={{
													className: classes.textInputLabel,
												}}
											/>
											<FormHelperText error={true}>
												{errorObj.lastName}
											</FormHelperText>
										</Col>
										<Col lg="6" md="6" sm="12" xs="12">
											<TextField
												variant="outlined"
												margin="normal"
												required
												fullWidth
												autoComplete="off"
												label="Email Address"
												name="email"
												autoFocus
												value={email}
												onChange={handleOnChange}
												InputProps={{
													className: classes.textInput,
												}}
												InputLabelProps={{
													className: classes.textInputLabel,
												}}
											/>
											<FormHelperText error={true}>
												{errorObj.emailId}
											</FormHelperText>
										</Col>
										<Col lg="6" md="6" sm="12" xs="12">
											<TextField
												variant="outlined"
												margin="normal"
												required
												fullWidth
												autoComplete="off"
												label="Confirm Email Address"
												name="confirmEmail"
												autoFocus
												value={confirmEmail}
												onChange={handleOnChange}
												InputProps={{
													className: classes.textInput,
												}}
												InputLabelProps={{
													className: classes.textInputLabel,
												}}
											/>
											<FormHelperText error={true}>
												{errorObj.confirmEmailId}
											</FormHelperText>
										</Col>
										<Col lg="6" md="6" sm="12" xs="12">
											<TextField
												variant="outlined"
												margin="normal"
												required
												fullWidth
												autoComplete="off"
												label="User name"
												name="userName"
												autoFocus
												value={userName}
												onChange={handleOnChange}
												InputProps={{
													className: classes.textInput,
												}}
												InputLabelProps={{
													className: classes.textInputLabel,
												}}
											/>
											<FormHelperText error={true}>
												{errorObj.username}
											</FormHelperText>
											{isUsernameExists && (
												<FormHelperText error={true}>
													{' '}
													Username already exists{' '}
												</FormHelperText>
											)}
										</Col>
										<Col lg="6" md="6" sm="12" xs="12">
											<TextField
												variant="outlined"
												margin="normal"
												required
												fullWidth
												autoComplete="off"
												label="Phone Number"
												name="phoneNumber"
												autoFocus
												value={phoneNumber}
												onChange={handleOnChange}
												onKeyDown={numOnly}
												InputProps={{
													className: classes.textInput,
												}}
												InputLabelProps={{
													className: classes.textInputLabel,
												}}
											/>
											<FormHelperText error={true}>
												{errorObj.phoneNumber}
											</FormHelperText>
										</Col>
										<Col lg="6" md="6" sm="12" xs="12">
											<TextField
												value={password}
												onChange={handleOnChange}
												variant="outlined"
												margin="normal"
												required
												fullWidth
												autoComplete="off"
												name="password"
												label="Password"
												type="password"
												id="password"
												InputProps={{
													className: classes.textInput,
												}}
												InputLabelProps={{
													className: classes.textInputLabel,
												}}
											/>
											<FormHelperText error={true}>
												{errorObj.password}
											</FormHelperText>
										</Col>
										<Col lg="6" md="6" sm="12" xs="12">
											<TextField
												value={confirmPassword}
												onChange={handleOnChange}
												variant="outlined"
												margin="normal"
												required
												fullWidth
												autoComplete="off"
												name="confirmPassword"
												label="Confirm Password"
												type="password"
												id="confirmpassword"
												InputProps={{
													className: classes.textInput,
												}}
												InputLabelProps={{
													className: classes.textInputLabel,
												}}
											/>
											<FormHelperText error={true}>
												{errorObj.confirmPassword}
											</FormHelperText>
										</Col>

										<Col lg="6" md="6" sm="12" xs="12">
											<TextField
												variant="outlined"
												margin="normal"
												required
												fullWidth
												autoComplete="off"
												label="Company Name"
												name="companyName"
												autoFocus
												value={companyName}
												onChange={handleOnChange}
												InputProps={{
													className: classes.textInput,
												}}
												InputLabelProps={{
													className: classes.textInputLabel,
												}}
											/>
											<FormHelperText error={true}>
												{errorObj.companyName}
											</FormHelperText>
											{isCompanyNameExists && (
												<FormHelperText error={true}>
													{' '}
													Company Name already exists{' '}
												</FormHelperText>
											)}
										</Col>
										<Col lg="6" md="6" sm="12" xs="12">
											<TextField
												variant="outlined"
												margin="normal"
												fullWidth
												autoComplete="off"
												label="GST Number"
												name="GSTNumber"
												autoFocus
												value={GSTNumber}
												onChange={handleOnChange}
												InputProps={{
													className: classes.textInput,
												}}
												InputLabelProps={{
													className: classes.textInputLabel,
												}}
											/>
										</Col>
									</Row>
									<Row>
										<Col lg="12" md="12" sm="12" xs="12">
											<FormControl
												variant="outlined"
												fullWidth
												className={classes.formControl}>
												<InputLabel id="demo-simple-select-outlined-label">
													Business Category
												</InputLabel>
												<Select
													labelId="demo-simple-select-outlined-label"
													id="demo-simple-select-outlined"
													value={businessCategory}
													name="businessCategory"
													onChange={handleOnChange}
													label="Business Category">
													{renderBusinessCategoryOptions()}
												</Select>
											</FormControl>
										</Col>
									</Row>
									<Row>
										<Col lg="3" md="6" sm="12" xs="12">
											<TextField
												variant="outlined"
												margin="normal"
												fullWidth
												autoComplete="off"
												label="Country"
												name="country"
												autoFocus
												value={country}
												onChange={handleOnChange}
												InputProps={{
													className: classes.textInput,
												}}
												InputLabelProps={{
													className: classes.textInputLabel,
												}}
											/>
										</Col>
										<Col lg="3" md="6" sm="12" xs="12">
											<TextField
												variant="outlined"
												margin="normal"
												fullWidth
												autoComplete="off"
												label="State"
												name="state"
												autoFocus
												value={state}
												onChange={handleOnChange}
												InputProps={{
													className: classes.textInput,
												}}
												InputLabelProps={{
													className: classes.textInputLabel,
												}}
											/>
										</Col>
										<Col lg="3" md="6" sm="12" xs="12">
											<TextField
												variant="outlined"
												margin="normal"
												fullWidth
												autoComplete="off"
												label="City"
												name="city"
												autoFocus
												value={city}
												onChange={handleOnChange}
												InputProps={{
													className: classes.textInput,
												}}
												InputLabelProps={{
													className: classes.textInputLabel,
												}}
											/>
										</Col>
										<Col lg="3" md="6" sm="12" xs="12">
											<TextField
												variant="outlined"
												margin="normal"
												fullWidth
												autoComplete="off"
												label="Zipcode"
												name="zipCode"
												autoFocus
												value={zipCode}
												onChange={handleOnChange}
												onKeyDown={numOnly}
												InputProps={{
													className: classes.textInput,
												}}
												InputLabelProps={{
													className: classes.textInputLabel,
												}}
											/>
										</Col>
										<Col lg="12" md="12" sm="12" xs="12">
											<TextField
												value={address}
												onChange={handleOnChange}
												variant="outlined"
												margin="normal"
												fullWidth
												autoComplete="off"
												name="address"
												label="Address"
												multiline
												maxRows={3}
											/>
										</Col>
									</Row>
									<Row>
										<Col>
											<button
												type="submit"
												className="registration-btn"
												onClick={saveRegestration}
												style={{ cursor: 'pointer' }}>
												<p className="registration-btn-text">
													REGISTER
												</p>
											</button>
										</Col>
										<Col className="d-flex justify-content-center align-items-center">
											<div className="">
												Already have account?
												<Link to={routes.LOGIN.path}> Login</Link>
											</div>
										</Col>
									</Row>
									{loginError !== '' && (
										<div className="error">{loginError}</div>
									)}
								</form>
							</div>
						</Col>
					</Row>
				</Card>
			</Container>
		</Root>
	);
};

export default Registration;
